import { render } from "./ItemPhoto.vue?vue&type=template&id=0c24e081&scoped=true&ts=true"
import script from "./ItemPhoto.vue?vue&type=script&lang=ts"
export * from "./ItemPhoto.vue?vue&type=script&lang=ts"

import "./ItemPhoto.vue?vue&type=style&index=0&id=0c24e081&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c24e081"]])

export default __exports__